import { createContext, useContext } from 'react';

import { useTheme } from '@course-authoring/shared-types';

export type SectionSurface = 'light' | 'dark';

const SectionSurfaceContext = createContext<SectionSurface>('light');

export const SectionSurfaceProvider = SectionSurfaceContext.Provider;

export function useSectionSurface(): SectionSurface {
  return useContext(SectionSurfaceContext);
}

/**
 * Returns the appropriate card background color based on the parent section surface.
 * - Light (white) parent → #F1F1F1
 * - Dark (gray) parent → #FCFCFC
 */
export function useCardBackground(): string {
  const { tokens } = useTheme();
  const surface = useSectionSurface();
  return surface === 'dark' ? '#FCFCFC' : tokens.backgrounds.cardAlt;
}
